const forceReflow = (element) => {
  if (!element) {
    return;
  }
  element.clientHeight;
};
export {
  forceReflow
};
//# sourceMappingURL=forceReflow.js.map
